import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpHeaders,
} from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { SemerisRoutes } from '../constants/routes';

@Injectable()
export class ResolutionInterceptor implements HttpInterceptor {
  public intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.includes(SemerisRoutes.heartbeat)) {
      return next.handle(req);
    }

    const resolution = window.innerWidth + 'x' + window.innerHeight;
    const headers: HttpHeaders = req.headers.set('X-Semeris-Resolution', resolution);
    return next.handle(req.clone({ headers }));
  }
}
